export default __webpack_public_path__ + "static/media/2.80a41da9.jpeg";